import { useState } from "react";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { Article } from "../../types/article";
import { ArticleListItemMobile, ListWrapper } from "../../styles/styles";
import { useTranslation } from "@coworker/locales";
import { FullWidthButton } from "../../../SkapaButton";
import { ModalTypes } from "../../types/views";
import { logEvent } from "../../../../helpers/tracker";
import { SimpleToast } from "@coworker/apprestructured/src/shared/simple/SimpleToast/SimpleToast";
import { filterMainArticles } from "../../Helpers/articleHelpers";
import { ItemListViewItemBasic } from "@coworker/apprestructured/src/media-maintenance/components/ItemListViewItemBasic/ItemListViewItemBasic";

interface PTagArticleSummaryForClipboardModalProps {
  selectedArticles: Article[];
  modalVisibility: boolean;
  onTriggerNewModal: (modalType: ModalTypes) => void;
}

export const PTagArticleSummaryForClipboardModal = ({
  selectedArticles,
  modalVisibility,
  onTriggerNewModal,
}: PTagArticleSummaryForClipboardModalProps) => {
  const { t } = useTranslation();
  const [toastVisible, setToastVisible] = useState(false);
  const [modalTypeForXButton, setModalTypeForXButton] = useState<ModalTypes>(
    ModalTypes.KEEP_SELECTION
  );

  const articlesWithoutPieces = filterMainArticles(selectedArticles).map(
    (article) => ({ ...article, nbrArticles: 0 })
  );

  return (
    <FixaModal
      visible={modalVisibility}
      handleCloseBtn={() => {
        setToastVisible(false);
        onTriggerNewModal(modalTypeForXButton);
      }}
    >
      <FixaSheets
        labelledById="media-ptag-article-summary-for-clipboard-modal-header"
        size={"small"}
        header={
          <FixaModalHeader
            id="media-ptag-article-summary-for-clipboard-modal-header"
            title={`${articlesWithoutPieces?.length ?? 0} ${t(
              "articlesLowerCaseString"
            )}`}
            ariaCloseTxt="Close"
          />
        }
        footer={
          <FixaModalFooter>
            <FullWidthButton
              text={t("copyAllArticleNumbersString")}
              type={"primary"}
              onClick={() => {
                navigator.clipboard.writeText(
                  articlesWithoutPieces
                    .map((article) => article.productArticleId)
                    .join("\n")
                );
                logEvent("ce:copyAllArticleNumbers");
                setToastVisible(true);
                setModalTypeForXButton(ModalTypes.DEFAULT_VIEW);
              }}
            />
          </FixaModalFooter>
        }
      >
        <>
          <ListWrapper>
            {articlesWithoutPieces.map((article) => (
              <ArticleListItemMobile key={article.id}>
                <ItemListViewItemBasic
                  article={article}
                  itemNo={article.productArticleId}
                />
              </ArticleListItemMobile>
            ))}
            {toastVisible && (
              <SimpleToast
                text={t("articleNumbersCopiedToClipboardString")}
                isOpen={toastVisible}
                onCloseRequest={() => {
                  setToastVisible(false);
                }}
                ariaLabel={t("articleNumbersCopiedToClipboardString")}
              />
            )}
          </ListWrapper>
        </>
      </FixaSheets>
    </FixaModal>
  );
};
